var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return ( !_vm.isShowTopNav() )?_c('div',{class:_vm.navbarClasses},[_c('TopHeader'),_c('ToolBar')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }